// extracted by mini-css-extract-plugin
module.exports = {"nav":"NavMenu_nav__2m2BS"};